import React, { Component } from 'react';
import { sessionManager } from '../../core/SessionManager';
import styles from './login.module.css';
import { post } from '../../utils/http'
import api from '../../utils/api'
import { Button, Typography, Input, Spin, Form, notification, Image } from 'antd';
import defaultImg from '../img/default.png';
import { encrypt } from '../../services/AuthService';
import { LoadingOutlined } from '@ant-design/icons';
import { commonUtil } from '../../utils/commonUtil';

const { Title } = Typography;

class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userName: "",
            passWord: "",
            loading: false,
            publicKey: "",
            OTP: "",
            loginStatus: true,
            QRCodeUrl: "",
            errorValue: ""
        }
    }

    getLogin = () => {
        if (this.state.publicKey !== "") {
            this.goHomePage();
        } else {
            var _this = this;
            post(api.getPublicKey).then(function (response) {
                _this.setState({ publicKey: response }, () => {
                    _this.goHomePage()
                })
            }).catch(function (error) {
                if(commonUtil.isJSON(error)){
                    notification['error']({
                        message: JSON.stringify(error.message),
                    });
                }else{
                    notification['error']({
                        message: error,
                    });
                }
            })
        }

    }

    verify = () => {
        const { userName, passWord, OTP, publicKey } = this.state;
        this.setState({
            loading: true
        });
        let verifyData = {
            uname: encrypt(userName, publicKey),
            passwd: encrypt(passWord, publicKey),
            otp: OTP
        }
        var _this = this;
        post(api.verify, verifyData).then(function (response) {
            sessionManager.setToken(response.accessToken)
            sessionManager.setRefreshToken(response.refresh_token)
            sessionManager.setUserInfo(response.userInfo);
            sessionManager.setUserId(response.userInfo.userId);
            sessionManager.setUserRole(response.userInfo.userRole);
            _this.setState({ loading: false }, () => {
                var userRole = response.userInfo.userRole;
                if (userRole === '1' || userRole === '2') {
                    var confirmData = new FormData();
                    confirmData.append("userRole", userRole);
                    confirmData.append("merchantId", 0);
                    post(api.getMenuList, confirmData).then(function (response1) {
                        sessionManager.setMenuList(response1);
                        _this.setState({ loading: false }, () => {
                            _this.props.history.push('./page/home');
                        });
                    }).catch(function (error) {
                        error = error.toString();
                        notification['error']({
                            message: error
                        })
                        _this.setState({ loginStatus: true, loading: false })
                    })
                    
                } else {
                    notification['error']({
                        message: 'This user has error role or has no role.',
                    });
                }
            })
        }).catch(function (error) {
            //error = error.toString();
            notification['error']({
                message: error,
            });
            _this.setState({ loginStatus: true, loading: false })
        })
    }

    goHomePage = () => {
        const { userName, passWord, publicKey } = this.state;
        if(passWord.length === 0){
            return ;
        }
        this.setState({
            loading: true
        })
        if(commonUtil.isEmail(userName)) {
            console.log('email login');
           
            let query = {
                uname: encrypt(userName, publicKey),
                passwd: encrypt(passWord, publicKey)
            }
            let _this = this;
            post(api.login, query).then(function (response) {
                _this.setState({ QRCodeUrl: response.QRCodeUrl, loginStatus: false, loading: false })
            }).catch(function (error) {
                notification['error']({
                    message: error,
                });
                _this.setState({ loading: false })
            });
        } else if (commonUtil.isMobile(userName)) {
            console.log('mobile login');
            let confirmData = new FormData();
            confirmData.append("userName", encrypt(userName, publicKey));
            confirmData.append("password", encrypt(passWord, publicKey));
            let _this = this;
		    post(api.telepinMobileDoLogin, confirmData).then(function(response){
			    sessionManager.setPrivilege(response.privilege);
			    sessionManager.setIsAdmin(response.isAdmin);
			    sessionManager.setMerchant(response.merchant);
			    sessionManager.setIsSMRTNonCFOUser(response.isSMRTNonCFOUser);
			    sessionManager.setNeedChangePassword(response.needChangePassword);
			    sessionManager.setTemporaryPassword(response.temporaryPassword);
			    sessionManager.setUserAuthenticatedTime(response.userAuthenticatedTime);
                sessionManager.setMerchantName(response.merchantName);
                
                if(response.userInfo){
                    sessionManager.setUserInfo(response.userInfo);
                    sessionManager.setUserId(response.userInfo.userId);
                    sessionManager.setUserRole(response.userInfo.userRole);
                    sessionManager.setToken(response.accessToken);
                    sessionManager.setRefreshToken(response.refresh_token);
                }
               
                sessionManager.setMerchantId(response.merchantId);

                _this.setState({ loading: false }, () => {

                    if(response.needChangePassword){
                        console.log('change password')
                        sessionManager.setMobileNum(userName);
                        //go to change password page after login if mobile user click the forget pwd and reset successfully
                        _this.props.history.push('../changeMobilePwd');
                        return;
                    }else {
                        //load the menu list and go home page
                        const confirmData1 = {
                            merchantId: response.merchantId,
                            userRole: 3,
                            privilegeModel: sessionManager.getPrivilege()
                        }

                        post(api.getMenuListByMobile, confirmData1).then(function (response) {
                            sessionManager.setMenuList(response);
                            _this.setState({ loading: false }, () => {
                                _this.props.history.push('./page/home');
                            });
                        }).catch(function (error) {
                            notification['error']({
                                message: error
                            })
                            _this.setState({ loading: false });
                        })
                    } 
                })
		    }).catch(function(error){
			    console.log(error);
                _this.setState({ loading: false });
                notification['error']({
                    message: 'Fail to login.',
                });
		    })
        } else {
            this.setState({
                loading: false
            })
            notification['error']({
                message: 'Please input valid user name.',
            });
        }
    }

    handleUserName = (e) => {
        this.setState({
            userName: e.target.value
        })
    }

    handlePwd = (e) => {
        this.setState({
            passWord: e.target.value
        })
    }

    handleOPT = (e) => {
        this.setState({
            OTP: e.target.value,
        })
    }

    forgetPwd = () => {
        this.props.history.push('../forgetPwd')
    }


    render() {

        return <div className={styles.container}>
            <div className={styles.content}  >
                <Title className={styles.title} style={{ color: "#a52387" }}>DASH Portal</Title>

                {this.state.loginStatus && <div> <Form name="basic" autoComplete="off" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ marginLeft: "-80px" }} >
                    <Form.Item label="Username" name="username" rules={[{ required: true, message: 'Please input your username!' }]} >
                        <Input size="large" className={styles.input} onChange={this.handleUserName} />
                    </Form.Item>

                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[{ required: true, message: 'Please input your password!' }]}
                    >
                        <Input.Password size="large" className={styles.input} onChange={this.handlePwd}/>
                    </Form.Item>

                    <div style={{ justifyContent: 'space-between', display: "flex", paddingLeft: ' 120px ' }}>
                        {!this.state.loading && <Button type="primary" htmlType="submit" size="large" onClick={this.getLogin}>
                            Login
                        </Button>}
                        {this.state.loading && <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: "#a52387" }} spin />} />}
                        <Button onClick={this.forgetPwd} size="large" type="link" style={{ color: '#a52387',marginRight:'7%' }} >Forget Password</Button>
                    </div>
                </Form></div>}


                {!this.state.loginStatus && <div>
                    {this.state.QRCodeUrl && <Image
                        alt="OTP"
                        width={150}
                        height={150}
                        fallback={defaultImg}
                        src={`data:image/png;base64, ${this.state.QRCodeUrl}`}
                    />}
                    <Form name="basic" autoComplete="off" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ marginLeft: "-80px" }} >
                        <Form.Item label="OTP" name="OTP" rules={[{ required: true, message: 'Please input your OTP!' }]}>
                            <Input maxLength={6} autoFocus={true} size="large" className={styles.input} onChange={this.handleOPT} />
                        </Form.Item>

                        <div style={{ justifyContent: 'space-between', display: "flex", paddingLeft: ' 120px ' }}>
                            {!this.state.loading && <Button type="primary" htmlType="button" size="large" onClick={this.verify}>
                                Verify
                            </Button>}
                            {this.state.loading && <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: "#a52387" }} spin />} />}
                        </div>
                    </Form>
                </div>}

            </div>
        </div>
    }
}

export default Login;
